import { reducer } from '@ardoq/rxbeach';
import {
  resetSurveyAccessRequestState,
  resetSurveyWorkspaceAccessRequestState,
  setSurveyAccessRequestLoading,
  setSurveyAccessRequestSent,
  setSurveyWorkspaceAccessRequestLoading,
  setSurveyWorkspaceAccessRequestSent,
} from './actions';
import { EntityBrowserAtomsStreamState } from './types';

const handleResetSurveyWorkspaceAccessRequestState = (
  state: EntityBrowserAtomsStreamState
): EntityBrowserAtomsStreamState => ({
  ...state,
  surveyWorkspaceAccessRequestLoading: false,
  surveyWorkspaceAccessRequestSent: false,
});

const handleSetSurveyWorkspaceAccessRequestLoading = (
  state: EntityBrowserAtomsStreamState,
  loading: boolean
): EntityBrowserAtomsStreamState => ({
  ...state,
  surveyWorkspaceAccessRequestLoading: loading,
});

const handleSetSurveyWorkspaceAccessRequestSent = (
  state: EntityBrowserAtomsStreamState,
  sent: boolean
): EntityBrowserAtomsStreamState => ({
  ...state,
  surveyWorkspaceAccessRequestSent: sent,
});

const handleResetSurveyAccessRequestState = (
  state: EntityBrowserAtomsStreamState
): EntityBrowserAtomsStreamState => ({
  ...state,
  surveyAccessRequestLoading: false,
  surveyAccessRequestSent: false,
});

const handleSetSurveyAccessRequestLoading = (
  state: EntityBrowserAtomsStreamState,
  loading: boolean
): EntityBrowserAtomsStreamState => ({
  ...state,
  surveyAccessRequestLoading: loading,
});

const handleSetSurveyAccessRequestSent = (
  state: EntityBrowserAtomsStreamState,
  sent: boolean
): EntityBrowserAtomsStreamState => ({
  ...state,
  surveyAccessRequestSent: sent,
});

export const reducers = [
  reducer(
    resetSurveyWorkspaceAccessRequestState,
    handleResetSurveyWorkspaceAccessRequestState
  ),
  reducer(
    setSurveyWorkspaceAccessRequestLoading,
    handleSetSurveyWorkspaceAccessRequestLoading
  ),
  reducer(
    setSurveyWorkspaceAccessRequestSent,
    handleSetSurveyWorkspaceAccessRequestSent
  ),
  reducer(resetSurveyAccessRequestState, handleResetSurveyAccessRequestState),
  reducer(setSurveyAccessRequestLoading, handleSetSurveyAccessRequestLoading),
  reducer(setSurveyAccessRequestSent, handleSetSurveyAccessRequestSent),
];
